import { createClient } from '@supabase/supabase-js';
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

console.log("🧩 Full Supabase key from env:", JSON.stringify(process.env.REACT_APP_SUPABASE_ANON_KEY));

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Supabase environment variables are missing');
}

// export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
//   auth: {
//     persistSession: false, // 🔒 log out when browser closed
//     autoRefreshToken: true,
//     detectSessionInUrl: true,
//   },
// });

// 🧩 Custom session storage (clears on browser close, not on refresh)
const sessionAdapter = {
  getItem: (key: string) => sessionStorage.getItem(key),
  setItem: (key: string, value: string) => sessionStorage.setItem(key, value),
  removeItem: (key: string) => sessionStorage.removeItem(key),
};

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    storage: sessionAdapter, // 💾 session-based persistence
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});

// 🧩 Expose Supabase client globally for troubleshooting (safe in dev)
if (typeof window !== 'undefined') {
  (window as any).supabase = supabase;
  console.log('🧭 Supabase client exposed:', supabaseUrl.slice(0, 40) + '...');
}
